import { axios } from "../../helper/axios";
import { ChargingStationConstant } from "./chargingStationConstant";

const chargingStationApi = {};

chargingStationApi.getChargingStations = async ({ from_date,
  to_date,
  search_term,
  page,
  sort,
  limit,
  network
}) => {
  
  let queryParam = "";

  if (page) {
    queryParam += `page=${page}&`;
  }
  if (sort) {
    queryParam += `sort=${sort}&`;
  }
  if (search_term) {
    queryParam += `search_term=${encodeURIComponent(search_term)}&`;
  }
  if (from_date && to_date) {
    queryParam += `startDate=${from_date}&endDate=${to_date}&`;
  }
  if (limit) {
    queryParam += `limit=${limit}&`;
  }  
  if (network) {
    queryParam += `network=${network}&`;
  }   
  return axios.get(
  `${ChargingStationConstant.CHARGING_STATION_API}?${queryParam} `
   
  );
};

chargingStationApi.getbulkexportChargingStations = async ({ 
 limit,
}) => {
  let queryParam = "";
 if (limit) {
    queryParam += `limit=${limit}&`;
  }   
  return axios.get(
  `${ChargingStationConstant.CHARGING_STATION_API}?${queryParam} `
   
  );
};
chargingStationApi.postBulkData = (file) => {
  
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(ChargingStationConstant.POST_CHARGING_STATION_BULK_API, formData);
};

chargingStationApi.getConnectotDropdown = async () => {
 return await  axios.get(
    ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_API
  );
};


chargingStationApi.deleteChargingStation = ({ id }) => {
  return axios.delete(
    ChargingStationConstant.CHARGING_STATION_DELETE_API.replace(":id", id)
  );
};

chargingStationApi.ChargingStationDetail = ({ id }) => {
  return axios.get(
    ChargingStationConstant.CHARGING_STATION_DETAIL_API.replace(":id", id)
  );
};

chargingStationApi.getChargingPoint = (station_id) => {
  let qeuryParam = `?station_id=${station_id}`;

  return axios.get(
    `${ChargingStationConstant.GET_CHARGING_POINT_API}${qeuryParam}`
  );
};

chargingStationApi.DeleteChargingConnectorApi = ({ id }) => {
  return axios.delete(
    ChargingStationConstant.DELETE_CHARGING_CONNECTOR_API.replace(":id", id)
  );
};

// add charging point

chargingStationApi.Add_ChargingPointApi = (payload) => {

  return axios.post(ChargingStationConstant.ADD_CHARGING_POINT_API, payload);
};

// add charging connector

chargingStationApi.Add_ChargingConnectorApi = ({
  charger_type_id,
  charge_point_id,
  price_per_khw,
  power,
}) => {
  const postConnectorData = {
    charger_type_id,
    charge_point_id,
    price_per_khw,
    power,
  };
  return axios.post(
    ChargingStationConstant.ADD_CHARGING_CONNECTOR_API,postConnectorData);
};

// edit charging point

chargingStationApi.Edit_ChargingPointApi = ({
  id,
  name,
  station_id,
  cp_id,
}) => {
  const postData = {
    id,
    name,
    station_id,
    cp_id,
  };
  return axios.put(ChargingStationConstant.EDIT_CHARGING_POINT_API, postData);
};

// edit charging Connector

chargingStationApi.Edit_ChargingConnecApi = ({
  id,
  charger_type_id,
  charge_point_id,
  price_per_khw,
  power,
}) => {
  const postDataUpdatedConnector = {
    id,
    charger_type_id,
    charge_point_id,
    price_per_khw,
    power,
  };
  return axios.put(
    ChargingStationConstant.EDIT_CHARGING_CONNECTOR_API,
    postDataUpdatedConnector
  );
};

// vendor select

chargingStationApi.getVendorSelectWiseApi = () => {
  return axios.get(ChargingStationConstant.GET_VENDOR_SELECT_WISE_API);
};

chargingStationApi.getStationNetworkApi = () => {
  return axios.get(ChargingStationConstant.CHARGING_STATION_NETWORK_API);
};

chargingStationApi.AddChargingTableEnableDisableApi = ({ id, status }) => {
  return axios.post(ChargingStationConstant.ENABLE_DESABLE_CHARGING_TABLE_API, {
    id: id,
    status: status,
  });
};

//csc
chargingStationApi.ApigetChargingStationCount = () => {
  return axios.get(ChargingStationConstant.CHARGING_STATION_COUNT_API);
};

//charging see all
chargingStationApi.getChargingStationSeeAllRequest = () => {
  return axios.get(ChargingStationConstant.CHARGING_SEEALLRES_API);
};

chargingStationApi.approveRejectApi = (id, status) => {
  return axios.post(ChargingStationConstant.CHARGING_APPROVE_DISABLE_API, {
    id: id,
    status: status,
  });
};
chargingStationApi.deleteStationApi = (id) => {
  
  
  return axios.delete(ChargingStationConstant.CHARGING_STATION_DELETE_API, {
    data: {
      ids: Array.isArray(id) ? id : [id], // Ensure 'ids' is always an array
    },
  });
};


export { chargingStationApi };
